import { Avatar as AntdAvatar } from 'antd'
import { AvatarProps } from 'antd/lib/avatar'

export const Avatar = (props: AvatarProps) => <AntdAvatar {...props} />
